var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('line-grid');
import { rgba } from 'polished';
import { useTheme } from '../hooks/use-theme';
export var LineGridDefaultProps = {
  backgroundColor: 'primary',
  majorDivisions: 10,
  minorDivisions: 10,
  majorWidth: 2,
  height: '400px',
  minorWidth: 1,
  majorOpacity: 1.0,
  middleMinorOpacity: 0.5,
  minorOpacity: 0.3,
  color: 'light',
  direction: 'both'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    position: relative;\n    ", "\n  "], ["\n    width: 100%;\n    position: relative;\n    ", "\n  "])), function (_a) {
    var _bg = _a._bg,
      _height = _a._height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n      height: ", ";\n    "], ["\n      background-color: ", ";\n      height: ", ";\n    "])), theme.COLOR(_bg), _height);
  })
});
var GridStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    height: 100%;\n    width: 100%;\n  "], ["\n    position: absolute;\n    height: 100%;\n    width: 100%;\n  "])))
});
var VerticalGridStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), GridStyles)
});
var HorizontalGridStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), GridStyles)
});
var LineStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    display: block;\n    z-index: 1;\n    ", "\n  "], ["\n    position: absolute;\n    display: block;\n    z-index: 1;\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      opacity = _a.opacity;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), rgba(_color, opacity));
  })
});
var HorizontalLineStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    width: 100%;\n    left: 0;\n    font-size: 0;\n    ", "\n  "], ["\n    ", ";\n    width: 100%;\n    left: 0;\n    font-size: 0;\n    ", "\n  "])), LineStyles, function (_a) {
    var size = _a.size;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), size);
  })
});
var VerticalLineStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    top: 0;\n    height: 100%;\n    font-size: 0;\n    ", "\n  "], ["\n    ", ";\n    top: 0;\n    height: 100%;\n    font-size: 0;\n    ", "\n  "])), LineStyles, function (_a) {
    var size = _a.size;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), size);
  })
});
var MinorVerticalLineStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), VerticalLineStyles)
});
var MinorHorizontalLineStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), HorizontalLineStyles)
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  VerticalGrid: styled.div.attrs(cls.attr('vertical-grid'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), VerticalGridStyles),
  VerticalLine: styled.span.attrs(cls.attr('vertical-line'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), VerticalLineStyles),
  MinorVerticalLine: styled.span.attrs(cls.attr('minor-vertical-line'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), MinorVerticalLineStyles),
  HorizontalGrid: styled.div.attrs(cls.attr('horizontal-grid'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), HorizontalGridStyles),
  HorizontalLine: styled.span.attrs(cls.attr('horizontal-line'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), HorizontalLineStyles),
  MinorHorizontalLine: styled.span.attrs(cls.attr('minor-horizontal-line'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), MinorHorizontalLineStyles)
};
export var LineGrid = function (props) {
  var className = props.className,
    color = props.color,
    backgroundColor = props.backgroundColor,
    majorWidth = props.majorWidth,
    minorWidth = props.minorWidth,
    majorDivisions = props.majorDivisions,
    minorDivisions = props.minorDivisions,
    direction = props.direction,
    majorOpacity = props.majorOpacity,
    minorOpacity = props.minorOpacity,
    middleMinorOpacity = props.middleMinorOpacity,
    height = props.height;
  var t = useTheme();
  var $ = function (func) {
    return func({
      theme: t
    });
  };
  var majorColor = $(theme.COLOR(props.color || props.majorColor));
  var minorColor = $(theme.COLOR(props.color || props.minorColor));
  // const gradients = flatten([...Array(majorDivisions).keys()].map(index => {
  //   const percentage = (100 * (index * (1 / majorDivisions))).toFixed(2);
  //   return [`transparent calc(${percentage}% - 1px)`, `${majorColor} ${percentage}%`, `${majorColor} calc(${percentage}% + ${majorWidth}px)`, `transparent calc(${percentage}% + ${majorWidth}px)`];
  // }));
  // console.log(gradients);
  var major = __spreadArray([], __read(Array(majorDivisions + 1).keys()), false);
  var minor = __spreadArray([], __read(Array(minorDivisions).keys()), false);
  var minorOffset = (majorWidth - minorWidth) / 2;
  return React.createElement(My.Container, {
    _height: height,
    _bg: $(theme.COLOR(backgroundColor)),
    className: cls.name(className)
  }, direction !== 'horizontal' && React.createElement(My.VerticalGrid, null, major.map(function (index) {
    var percentage = 100 * (index * (1 / majorDivisions));
    return React.createElement(React.Fragment, {
      key: "v-".concat(index)
    }, React.createElement(My.VerticalLine, {
      key: "major-vertical-line-".concat(index),
      _color: majorColor,
      opacity: majorOpacity,
      size: majorWidth,
      style: {
        left: "calc(".concat(percentage.toFixed(2), "% - ").concat(index * ((majorWidth / 2 + 1) / majorDivisions), "px)")
      }
    }), index !== majorDivisions && minor.map(function (minorIndex) {
      var minorPercentage = percentage + 100 * (minorIndex * (1 / (majorDivisions * minorDivisions)));
      return React.createElement(My.MinorVerticalLine, {
        key: "minor-vertical-line-".concat(index, "-").concat(minorIndex),
        _color: minorColor,
        opacity: minorIndex === minorDivisions / 2 ? middleMinorOpacity : minorOpacity,
        size: minorWidth,
        style: {
          left: "calc(".concat(minorOffset, "px + ").concat(minorPercentage.toFixed(2), "% - ").concat(index * ((majorWidth / 2 + 1) / majorDivisions), "px)")
        }
      });
    }));
  })), direction !== 'vertical' && React.createElement(My.HorizontalGrid, null, major.map(function (index) {
    var percentage = 100 * (index * (1 / majorDivisions));
    return React.createElement(React.Fragment, {
      key: "h-".concat(index)
    }, React.createElement(My.HorizontalLine, {
      key: "major-horizontal-line-".concat(index),
      _color: majorColor,
      size: majorWidth,
      opacity: majorOpacity,
      style: {
        top: "".concat(percentage.toFixed(2), "%")
      }
    }), minor.map(function (minorIndex) {
      var minorPercentage = percentage + 100 * (minorIndex * (1 / (majorDivisions * minorDivisions)));
      return React.createElement(My.MinorHorizontalLine, {
        key: "minor-horizontal-line-".concat(index, "-").concat(minorIndex),
        _color: minorColor,
        opacity: minorIndex === minorDivisions / 2 ? middleMinorOpacity : minorOpacity,
        size: minorWidth,
        style: {
          top: "calc(".concat(minorOffset, "px + ").concat(minorPercentage.toFixed(2), "%)")
        }
      });
    }));
  })));
};
LineGrid.defaultProps = LineGridDefaultProps;
LineGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;